























































import { LoadingStatusType, Package } from "@/enums/enums";
import { GetBadgePackageClass, GetBadgePackageName } from "@/helper/merchantHelper";
import { MerchantInFoModel } from "@/model/merchant/MerchantInFoModel";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreUserInfo = namespace("UserInfo");

@Component
export default class CompanyList extends Vue {
  private listDisplay: any = [];
  private listMerchant: Array<MerchantInFoModel> = [];
  private listFilter: Array<MerchantInFoModel> = [];
  private inputSearch: any = "";
  private isTimeout = 0;
  private selectedMerchant: any = null;
  private Package = Package;
  private GetBadgePackageClass = GetBadgePackageClass;
  private GetBadgePackageName = GetBadgePackageName;

  @StoreUserInfo.Getter
  private getMerchantList!: Array<MerchantInFoModel>;
  @StoreUserInfo.Getter
  private getMerchantListLoadingStatus!: LoadingStatusType;
  @StoreUserInfo.Getter
  private getMerchantModelListForMap!: Map<number, SelectedMerchantModel>;

  @StoreUserInfo.Action
  private DoGetMerchantList!: () => void;
  @StoreUserInfo.Action
  private DoGetMerchantModelById!: (merchantId: number) => Promise<SelectedMerchantModel>;

  mounted() {
    const listBox: any = this.$refs.listBox;
    listBox.addEventListener("scroll", this.HandleScroll);
  }

  @Watch("inputSearch")
  inputSearchChanged() {
    clearTimeout(this.isTimeout);
    this.isTimeout = setTimeout(() => {
      const listBox: any = this.$refs.listBox;
      listBox.scroll({
        top: 0,
        behavior: "smooth",
      });
      this.SetListFilter();
      this.ResetDatalistDisplay();
    }, 250);
  }

  @Watch("getMerchantListLoadingStatus", { immediate: true })
  getMerchantListLoadingStatusChange(newValue: LoadingStatusType) {
    if (newValue === LoadingStatusType.Success) {
      this.listMerchant = this.getMerchantList;
      this.SetListFilter();
      this.ResetDatalistDisplay();
    } else if (newValue === LoadingStatusType.None) {
      this.DoGetMerchantList();
    }
  }

  public SetListFilter() {
    const text = this.inputSearch.toLowerCase();
    if (text) {
      this.listFilter = this.listMerchant.filter((item) => {
        if (item.merchantName) {
          return item.merchantName.toLowerCase().includes(text.toLowerCase());
        }
        return false;
      });
    } else {
      this.listFilter = this.listMerchant;
    }
  }

  public HandleScroll() {
    const listBox: any = this.$refs.listBox;
    const scrollHeight = listBox.scrollHeight;
    const scrollTop = listBox.scrollTop;
    const clientHeight = listBox.clientHeight;
    const scroll = scrollHeight - (scrollTop + clientHeight);
    if (scroll < 300) {
      if (this.listDisplay.length < this.listFilter.length) {
        this.listDisplay.push({ merchantId: this.listFilter[this.listDisplay.length].merchantId });
        this.GetMerchantModel(this.listDisplay[this.listDisplay.length - 1].merchantId);
      }
    }
  }

  public ResetDatalistDisplay() {
    this.listDisplay = [];
    for (let i = 0; i < 10; i++) {
      if (i < this.listFilter.length) {
        this.listDisplay.push({ merchantId: this.listFilter[i].merchantId });
        this.GetMerchantModel(this.listFilter[i].merchantId);
      }
    }
  }

  public GetMerchantModel(merchantId: number) {
    this.DoGetMerchantModelById(merchantId).then((merchant) => {
      const indexMerchant = this.listDisplay.findIndex((x: any) => x.merchantId == merchantId);
      if (indexMerchant > -1) {
        this.listDisplay.splice(indexMerchant, 1, merchant);
      }

      if (!this.selectedMerchant && indexMerchant == 0) {
        this.SelectCompany(merchant);
      }
    });
  }

  public SelectCompany(merchant: SelectedMerchantModel) {
    this.listDisplay.forEach((company: any) => {
      if (company.merchantId === merchant.merchantId) {
        company.active = true;
        this.$emit("update:company", company);
      } else {
        company.active = false;
      }
    });
  }
}
